/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { useDispatch } from "react-redux";
import { InsertProject } from "../../Redux/ProjectSlice";
import moment from "moment";
import Select from "react-select";
import { LabelOptions, Phase, } from "../Common/Common";
import { useSelector } from "react-redux";
import { getAllPerson } from "../../Redux/PersonSlice";
import { fetchApiData } from "../../Redux/organizationSlice";
import { getAllDeals } from "../../Redux/DealSlice";
import ReactSelect, { getReactSelectStyles } from "../Common/ReactSelect";
import { getAlltemplates } from "../../Redux/TemplateSlice";

export default function AddProject({
  toggleModal,
  setloadFrist,
  EditProjectData,
}) {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();
  const dispatch = useDispatch();

  const Peoplestore = useSelector((state) => state.root.Person);
  const organizationstore = useSelector((state) => state.root.organization);
  const Dealstore = useSelector((state) => state.root.Deal);
  const TemplateStore = useSelector((store) => store.root.Templates)

  const [Label, setLabel] = useState([]);
  const [selectedLable, setselectedLable] = useState('');
  const [selectedDeal, setSelectedDeal] = useState({
    Deal: [],
    deals: ""
  });

  const [selectedPerson, setSelectedPerson] = useState("");
  const [selectedOrganization, setSelectedOrganization] = useState("");
  const [startDate, setstartDate] = useState(moment().format("YYYY-MM-DD"));

  const [Enddate, setEnddate] = useState(moment().format("YYYY-MM-DD"));
  const [selectedPhase, setselectedPhase] = useState("Kickoff");
  const [selectedTemplate, setselectedTemplate] = useState('');
  const [showTooltip, setShowTooltip] = useState(false);
  const [tooltipContent, setTooltipContent] = useState('');

  const handleMouseEnter = (name) => { setShowTooltip(true); setTooltipContent(name); };
  const handleMouseLeave = () => { setShowTooltip(false); setTooltipContent(''); };


  useEffect(() => {
    dispatch(fetchApiData({}));
    dispatch(getAllPerson({}));
    dispatch(getAllDeals({}));
    dispatch(getAlltemplates({}))
  }, []);

  useEffect(() => {
    if (EditProjectData) {
      setValue("Title", EditProjectData?.title);
      setValue("Description", EditProjectData?.description);
      if (EditProjectData?.endDateTime) { setEnddate(moment(EditProjectData?.endDateTime).format("YYYY-MM-DD")) }
      if (EditProjectData?.startDateTime) { setstartDate(moment(EditProjectData?.startDateTime).format("YYYY-MM-DD")) }
      if (EditProjectData?.labelName) { setselectedLable(EditProjectData?.labelName); }
      if (EditProjectData?.contactPersonID) { setSelectedPerson({ label: EditProjectData?.contactPerson, value: EditProjectData?.contactPersonID, }) }
      if (EditProjectData?.organizationID) { setSelectedOrganization({ label: EditProjectData?.organizationName, value: EditProjectData?.organizationID, }) }
      if (EditProjectData?.templateID) { setselectedTemplate({ label: EditProjectData?.projectTemplateName, value: EditProjectData?.templateID, }) }
      if (EditProjectData?.phase) setselectedPhase(EditProjectData.phase ? EditProjectData.phase : selectedPhase)

      if (EditProjectData?.deal) {
        const initialDeals = EditProjectData?.deal?.map(deal => ({
          value: deal?.dealID,
          label: deal?.title,
        }));
        setSelectedDeal(prevState => ({
          ...prevState,
          Deal: initialDeals
        }));
      }
    }
  }, [EditProjectData, setValue]);

  useEffect(() => {
    const selectedValues = Label?.map((option) => option?.value).join(', ');
    setselectedLable(selectedValues);
  }, [Label]);

  useEffect(() => {
    const selectedValues = selectedDeal?.Deal?.map((option) => option?.value).join(', ');
    setSelectedDeal({ ...selectedDeal, deals: selectedValues });
  }, [selectedDeal?.Deal]);

  useEffect(() => {
    if (EditProjectData?.labelName) {
      const initialSelectedLabels = LabelOptions?.filter((option) => selectedLable.split(', ').includes(option?.value));
      setLabel(initialSelectedLabels);
    }
  }, [selectedLable]);

  const handleLabelChange = (selectedOptions) => { setLabel(selectedOptions) };

  const onSubmit = async (data) => {
    const Params = {
      projectID: EditProjectData?.projectID ? EditProjectData?.projectID : 0,
      title: data.Title,
      startDateTime: startDate,
      endDateTime: Enddate,
      boardName: data.Board,
      phase: selectedPhase,
      ownerID: 0,
      dealID: selectedDeal?.deals,
      contactPersonID: selectedPerson?.value,
      organizationID: selectedOrganization?.value,
      userID: 0,
      ownerName: "",
      templateID: selectedTemplate?.value,
      description: data.Description,
      labelName: selectedLable,
      isArchived: true,
      canceled: EditProjectData?.canceled ? EditProjectData?.canceled : EditProjectData?.canceled === 0 ? 0 : 3
    };

    try {
      const res = await dispatch(InsertProject(Params));
      if (res.payload.status === true) {
        toggleModal();
        setloadFrist(true);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleButtonClick = (message) => { setselectedPhase(message); };
  const currentIndex = Phase.findIndex(stage => stage.name === selectedPhase);

  return (
    <div>
      <div
        id="default-modal"
        tabIndex="-1"
        aria-hidden="true"
        className="fixed h-full top-0 right-0 left-0 z-[9999] flex justify-center items-center w-full md:inset-0 max-h-full bg-slate-900/60 backdrop-blur-sm transition-all duration-300"
      >
        <div className="relative p-4 w-full max-w-2xl max-h-full transition-transform duration-300 scale-100">
          <div className="relative bg-white dark:bg-slate-900 rounded-2xl shadow-2xl border border-slate-100 dark:border-slate-800 overflow-hidden flex flex-col">
            <div className="flex items-center justify-between p-4 md:p-5 border-b border-slate-100 dark:border-slate-800 bg-slate-50/50 dark:bg-slate-900/50">
              <h3 className="text-lg font-bold text-slate-800 dark:text-white">
                {EditProjectData?.projectID ? "Update Project" : "Add Project"}
              </h3>
              <button
                type="button"
                onClick={toggleModal}
                className="text-slate-400 hover:text-slate-600 dark:hover:text-slate-300 transition-colors p-1.5 hover:bg-slate-100 dark:hover:bg-slate-800 rounded-lg cursor-pointer"
              >
                <AiOutlineCloseCircle className="text-2xl" />
              </button>
            </div>

            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="max-h-[60vh] overflow-y-auto vertical-scroll-inner relative">
                <div className="px-6 py-5 space-y-4">
                  <div className="grid gap-4 grid-cols-2">
                    <div className="col-span-2 sm:col-span-1">
                      <label
                        htmlFor="Title"
                        className="block mb-1.5 text-xs font-bold text-slate-600 dark:text-slate-400 tracking-wide"
                      >
                        Title
                      </label>
                      <input
                        type="text"
                        {...register("Title", {
                          required: "Title is required",
                        })}
                        name="Title"
                        id="Title"
                        placeholder="Enter project title"
                        className="capitalize w-full bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-slate-800 dark:text-slate-100 text-sm rounded-lg focus:border-indigo-500 focus:ring-2 focus:ring-indigo-100 dark:focus:ring-indigo-950/50 p-2.5 outline-none transition-all duration-200 placeholder-slate-400 dark:placeholder-slate-500"
                      />
                      {errors.Title && (
                        <span className="error text-red-500 text-xs mt-1 block">
                          {errors.Title.message}
                        </span>
                      )}
                    </div>
                    <div className="col-span-2 sm:col-span-1">
                      <label
                        htmlFor="template"
                        className="block mb-1.5 text-xs font-bold text-slate-600 dark:text-slate-400 tracking-wide"
                      >
                        Select template
                      </label>
                      <ReactSelect
                        className="basic-single"
                        classNamePrefix="select"
                        selectedValue={selectedTemplate}
                        handleSelectChange={(option) => setselectedTemplate(option)}
                        options={
                          TemplateStore && TemplateStore?.getAllTemplates?.length > 0
                            ? TemplateStore?.getAllTemplates.map((item) => ({
                              value: item?.projectTemplateID,
                              label: item?.name,
                            }))
                            : [{ value: "", label: "Not Found" }]
                        }
                      />
                    </div>
                  </div>

                  <div className="grid gap-4 grid-cols-2">
                    <div className="col-span-2 sm:col-span-1">
                      <label
                        htmlFor="Startdate"
                        className="block mb-1.5 text-xs font-bold text-slate-600 dark:text-slate-400 tracking-wide"
                      >
                        Start date
                      </label>
                      <input
                        type="date"
                        {...register("Startdate")}
                        value={startDate}
                        onChange={(e) => {
                          const selectedDate = e.target.value;
                          setstartDate(selectedDate);
                          const MatchDates = selectedDate === Enddate
                          setEnddate(MatchDates ? Enddate : selectedDate > Enddate ? selectedDate : Enddate)
                        }}
                        name="Startdate"
                        id="Startdate"
                        className="w-full bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-slate-800 dark:text-slate-100 text-sm rounded-lg focus:border-indigo-500 focus:ring-2 focus:ring-indigo-100 dark:focus:ring-indigo-950/50 p-2.5 outline-none transition-all duration-200"
                      />
                    </div>
                    <div className="col-span-2 sm:col-span-1">
                      <label
                        htmlFor="Enddate"
                        className="block mb-1.5 text-xs font-bold text-slate-600 dark:text-slate-400 tracking-wide"
                      >
                        End date
                      </label>
                      <input
                        type="date"
                        value={Enddate}
                        min={startDate}
                        onChange={(e) => {
                          setEnddate(e.target.value);
                        }}
                        name="Enddate"
                        id="Enddate"
                        className="w-full bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-slate-800 dark:text-slate-100 text-sm rounded-lg focus:border-indigo-500 focus:ring-2 focus:ring-indigo-100 dark:focus:ring-indigo-950/50 p-2.5 outline-none transition-all duration-200"
                      />
                    </div>
                  </div>

                  <div className="grid gap-4 grid-cols-2">
                    <div className="col-span-2 sm:col-span-1 flex justify- flex-col">
                      <label
                        htmlFor="Phase"
                        className="block mb-1.5 text-xs font-bold text-slate-600 dark:text-slate-400 tracking-wide"
                      >
                        Phase
                      </label>
                      <div className="step-bar-list relative group ">
                        <ul id="pipelineList" className="flex items-center justify-between bg-white dark:bg-slate-400 rounded-full overflow-hidden">
                          {Phase.map((stage, index) => (
                            <>
                              <li
                                key={index}
                                className={`${index <= currentIndex ? 'active' : ''} cursor-pointer text-nowrap relative h-6`}
                                onClick={() => handleButtonClick(stage?.name)}
                                onMouseEnter={(e) => handleMouseEnter(stage?.name)}
                                onMouseLeave={handleMouseLeave}
                              >
                              </li>
                            </>
                          ))}
                          {showTooltip && tooltipContent && (
                            <div className={`absolute bottom-4 flex-col items-center hidden mb-6 group-hover:flex ${tooltipContent === 'Kickoff' ? 'left-5' : tooltipContent === 'Planning' ? 'left-32' : tooltipContent === 'Implementation' ? 'left-52' : tooltipContent === 'Review' ? 'right-32' : 'right-5'}`}>
                              <span className="relative z-10 p-2 text-xs leading-none text-white whitespace-no-wrap bg-black rounded-md">
                                {tooltipContent}
                              </span>
                              <div className="w-3 h-3 -mt-2 rotate-45 bg-black"></div>
                            </div>
                          )}

                        </ul>
                      </div>
                    </div>
                    <div className="col-span-2 sm:col-span-1">
                      <label
                        htmlFor="Board"
                        className="block mb-1.5 text-xs font-bold text-slate-600 dark:text-slate-400 tracking-wide"
                      >
                        Board
                      </label>
                      <select
                        id="Board"
                        className="w-full bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-slate-800 dark:text-slate-100 text-sm rounded-lg focus:border-indigo-500 focus:ring-2 focus:ring-indigo-100 dark:focus:ring-indigo-950/50 p-2.5 outline-none transition-all duration-200 appearance-none pr-8 bg-[url('data:image/svg+xml;charset=UTF-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22none%22%20stroke%3D%22%252364748b%22%20stroke-width%3D%222%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%3E%3Cpolyline%20points%3D%226%209%2012%2015%2018%209%22%3E%3C%2Fpolyline%3E%3C%2Fsvg%3E')] bg-[length:1.25rem] bg-[right_0.5rem_center] bg-no-repeat"
                        {...register("Board")}
                        onChange={(e) => {
                          setValue("Board", e.target.value);
                        }}
                      >
                        <option>Delivery</option>
                      </select>
                    </div>
                  </div>

                  <div className="grid gap-4 grid-cols-2">
                    <div className="col-span-2 sm:col-span-1">
                      <label
                        htmlFor="Owner"
                        className="block mb-1.5 text-xs font-bold text-slate-600 dark:text-slate-400 tracking-wide"
                      >
                        Owner
                      </label>
                      <input
                        type="text"
                        {...register("Owner")}
                        id="Owner"
                        placeholder="Project owner"
                        className="w-full bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-slate-800 dark:text-slate-100 text-sm rounded-lg focus:border-indigo-500 focus:ring-2 focus:ring-indigo-100 dark:focus:ring-indigo-950/50 p-2.5 outline-none transition-all duration-200 placeholder-slate-400 dark:placeholder-slate-500"
                      />
                    </div>

                    <div className="col-span-2 sm:col-span-1">
                      <label
                        htmlFor="deals"
                        className="block mb-1.5 text-xs font-bold text-slate-600 dark:text-slate-400 tracking-wide"
                      >
                        Deals
                      </label>
                      <Select
                        value={selectedDeal?.Deal}
                        isMulti
                        name="Participants"
                        options={
                          Dealstore && Dealstore?.getDeals?.length > 0
                            ? Dealstore.getDeals.map((item) => ({
                              value: item?.dealID,
                              label: item?.title,
                            }))
                            : [{ value: "", label: "Not Found" }]
                        }
                        className="basic-multi-select"
                        classNamePrefix="select"
                        onChange={(option) => { setSelectedDeal({ ...selectedDeal, Deal: option }) }}
                        styles={getReactSelectStyles()}
                      />
                    </div>
                  </div>
                  <div className="grid gap-4 grid-cols-2">
                    <div className="col-span-2 sm:col-span-1">
                      <label
                        htmlFor="contactPerson"
                        className="block mb-1.5 text-xs font-bold text-slate-600 dark:text-slate-400 tracking-wide"
                      >
                        Contact person
                      </label>
                      <ReactSelect
                        className="basic-single"
                        classNamePrefix="select"
                        selectedValue={selectedPerson}
                        handleSelectChange={(option) => setSelectedPerson(option)}
                        options={
                          Peoplestore && Peoplestore?.getAllPerson?.length > 0
                            ? Peoplestore.getAllPerson.map((item) => ({
                              value: item?.personMasterID,
                              label: item?.name,
                            }))
                            : [{ value: "", label: "Not Found" }]
                        }
                      />
                    </div>
                    <div className="col-span-2 sm:col-span-1">
                      <label htmlFor="organization" className="block mb-1.5 text-xs font-bold text-slate-600 dark:text-slate-400 tracking-wide">
                        Organization
                      </label>
                      <ReactSelect
                        className="basic-single"
                        classNamePrefix="select"
                        handleSelectChange={(option) => setSelectedOrganization(option)}
                        name="Organization"
                        selectedValue={selectedOrganization}
                        options={
                          organizationstore &&
                            organizationstore?.organizationData?.data?.length > 0
                            ? organizationstore?.organizationData?.data.map(
                              (item) => ({
                                value: item?.organizationID ?? "",
                                label: item?.organizationName,
                              })
                            )
                            : [{ value: "", label: "Not Found" }]
                        }
                      />
                    </div>
                  </div>

                  <div className="grid gap-4 grid-cols-2">
                    <div className="col-span-2 sm:col-span-1">
                      <label
                        htmlFor="labels"
                        className="block mb-1.5 text-xs font-bold text-slate-600 dark:text-slate-400 tracking-wide"
                      >
                        Labels
                      </label>
                      <Select
                        value={Label}
                        isMulti
                        name="colors"
                        options={LabelOptions}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        onChange={handleLabelChange}
                        styles={getReactSelectStyles()}
                      />
                    </div>
                    <div className="col-span-2 sm:col-span-1">
                      <label
                        htmlFor="description"
                        className="block mb-1.5 text-xs font-bold text-slate-600 dark:text-slate-400 tracking-wide"
                      >
                        Description
                      </label>
                      <textarea
                        type="text"
                        {...register("Description")}
                        id="description"
                        placeholder="Enter project description"
                        className="w-full bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-slate-800 dark:text-slate-100 text-sm rounded-lg focus:border-indigo-500 focus:ring-2 focus:ring-indigo-100 dark:focus:ring-indigo-950/50 p-2.5 outline-none transition-all duration-200 min-h-[80px] resize-y placeholder-slate-400 dark:placeholder-slate-500"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="mt-4 flex flex-wrap justify-between shrink-0 p-4 border-t border-slate-100 dark:border-slate-800 bg-slate-50 dark:bg-slate-900/50">
                <button
                  type="button"
                  className="px-4 py-2 border border-slate-200 dark:border-slate-700 text-slate-600 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-800 text-sm font-semibold rounded-lg transition-colors cursor-pointer mr-2"
                  onClick={toggleModal}
                >
                  Close
                </button>
                <button
                  type="submit"
                  className="px-5 py-2 bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-semibold rounded-lg shadow-md hover:shadow-lg transition-all duration-200 cursor-pointer"
                >
                  {EditProjectData?.projectID ? "Update" : "Save"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
